import utils from '../../common/utils';
import window from '../../common/window/windowWrapper';

var DimensionsHelper =
/*#__PURE__*/
function () {
  function DimensionsHelper() {
    this.styles = {};
    this.container = {};
    this.domId = '';
    this._cache = {};
  }

  var _proto = DimensionsHelper.prototype;

  _proto.getOrPutInCache = function getOrPutInCache(field, createValue) {
    if (this._cache[field]) return this._cache[field];
    this._cache[field] = createValue();
    return this._cache[field];
  };

  _proto.dumpCache = function dumpCache() {
    this._cache = {};
  };

  _proto.updateParams = function updateParams(_ref) {
    var styles = _ref.styles,
        container = _ref.container,
        domId = _ref.domId;
    this.dumpCache();
    this.domId = domId || this.domId;
    this.styles = styles || this.styles;
    this.container = container || this.container;
  };

  _proto.getDimensionFix = function getDimensionFix() {
    var _this = this;

    return this.getOrPutInCache('dimensionFix', function () {
      return Number(_this.styles.imageMargin) - Number(_this.styles.galleryMargin);
    });
  };

  _proto.isFullWidth = function isFullWidth(container) {
    if (container === void 0) {
      container = this.container;
    }

    //if the container width is not a number, it is fullwidth (e.g.: "", "100%", "calc(100% + -160px)")
    return !!container && String(parseInt(container.width)) !== String(container.width);
  };

  _proto.getGalleryDimensions = function getGalleryDimensions() {
    var _this2 = this;

    return this.getOrPutInCache('galleryDimensions', function () {
      var container = _this2.container;
      var res = {
        galleryWidth: _this2.getGalleryWidth(),
        galleryHeight: _this2.getGalleryHeight(),
        scrollBase: container.scrollBase || 0,
        height: container.height,
        width: container.width
      };

      if (_this2.styles.hasThumbnails) {
        var fixedThumbnailSize = _this2.styles.thumbnailSize + _this2.styles.galleryMargin + 3 * _this2.styles.thumbnailSpacings;

        switch (_this2.styles.galleryThumbnailsAlignment) {
          case 'top':
          case 'bottom':
            res.galleryHeight -= fixedThumbnailSize;
            break;

          case 'left':
          case 'right':
            res.galleryWidth -= fixedThumbnailSize;
            break;

          default:
            break;
        }
      } else if (_this2.styles.isSlideshow) {
        res.galleryHeight -= _this2.styles.slideshowInfoSize;
      }

      return res;
    });
  };

  _proto.getGalleryWidth = function getGalleryWidth() {
    var _this3 = this;

    return this.getOrPutInCache('galleryWidth', function () {
      var domWidth = function domWidth() {
        return window.isMock ? utils.getScreenWidth() : window.innerWidth;
      };

      var width = Math.floor((_this3.container.width > 0 ? _this3.container.width : domWidth()) + _this3.getDimensionFix() * 2); //add margins to width and then remove them in css negative margins

      if (_this3.styles.arrowsPosition && _this3.styles.oneRow) {
        width -= 2 * (_this3.styles.arrowsSize + 40 + _this3.styles.imageMargin);
      }

      return width;
    });
  };

  _proto.getGalleryHeight = function getGalleryHeight() {
    var _this4 = this;

    return this.getOrPutInCache('galleryHeight', function () {
      //const offsetTop = this.styles.oneRow ? this.container.offsetTop : 0;
      var dimensionFix = function dimensionFix() {
        return _this4.styles.oneRow ? _this4.getDimensionFix() : 0;
      };

      var domHeight = function domHeight() {
        return window.isMock ? utils.getScreenHeight() : window.innerHeight;
      }; //() => protectGalleryHeight(this.container.windowHeight, offsetTop);


      return Math.floor((_this4.container.height > 0 ? _this4.container.height : domHeight()) + dimensionFix());
    });
  };

  _proto.getGalleryRatio = function getGalleryRatio() {
    var _this5 = this;

    return this.getOrPutInCache('galleryRatio', function () {
      var res = _this5.getGalleryDimensions();

      return res.galleryWidth / res.galleryHeight;
    });
  };

  return DimensionsHelper;
}();

export default new DimensionsHelper();